import { takeLatest } from 'redux-saga/effects';
import { GET_BUSINESS_APPOINTMENTS_TYPE } from '../../../actions/businessAppointments';
import { getBusinessAppointments } from './getBusinessAppointments';

export function* businessRootSaga() {
  yield takeLatest(GET_BUSINESS_APPOINTMENTS_TYPE, getBusinessAppointments);
}
